import { Box, Typography, Popover, Button, List, Tooltip, ListItem } from '@mui/material';

import { useTranslation } from 'react-i18next';
import React, { useContext, useEffect, useState } from 'react';
import Scrollbar from 'react-scrollbars-custom';
import CoverageAccordion from './CoverageAccordion';
import { MapContext } from '@/context/MapContext/MapProvider';
import GeoJSONLayer from '@arcgis/core/layers/GeoJSONLayer';
import { geojsonUrls } from '@/constants';
export default function LayersPopover() {
  //Map states
  const { groupLayer, map } = useContext(MapContext);

  // popover states
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [isActive, setIsActive] = useState(false);

  // Accordion states
  const [expanded, setExpanded] = React.useState<string | false>(false);

  // list states
  const [checked, setChecked] = useState<{ [key: string]: boolean }>({
    2025: false,
    2024: false,
    2023: false,
    2022: false,
    2021: false,
    2020: false,
    2019: false,
    2018: false,
  });

  const { t } = useTranslation('orderImagery');

  useEffect(() => {
    if (!map) return;

    let startYear = 2025;

    groupLayer.when(() => {
      const polygonRenderer: any = {
        type: 'simple',

        symbol: {
          color: [0, 150, 255, 0.4],
          style: 'solid',
          type: 'simple-fill',
          outline: {
            type: 'simple-line',
            style: 'solid',
            color: [255, 255, 255, 0.7],
            width: 0.75,
          },
        },
      };
      try {
        geojsonUrls.forEach(value => {
          const geojsonLayer = new GeoJSONLayer({
            id: `${startYear}`,
            url: value,

            // opacity: 0, // dont see opacity optimization problem
            visible: false,
            renderer: polygonRenderer,
          });
          startYear--;
          groupLayer.add(geojsonLayer);
          geojsonLayer.load();

          // refreshing the layer to preload all the data
          // geojsonLayer.when(() => {

          // })
        });
      } catch (error) {
        console.log('layers error: ', error);
      }
    });
  }, [map, groupLayer]);
  const handleClose = () => {
    setAnchorEl(null);
    setIsActive(false);
  };

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    event.stopPropagation();
    event.preventDefault();
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Tooltip
        slotProps={{
          popper: {
            className: 'thm-dark-tooltip',
          },
        }}
        title="Layers"
        arrow
        placement="left"
      >
        <Button
          aria-label="change-basemap-button"
          name="change-basemap-button"
          variant="contained"
          onClick={async event => {
            // await basemapToggle.toggle();

            setAnchorEl(event.currentTarget);
            setIsActive(true);
          }}
        >
          <i className="icon-map-layers1"></i>
        </Button>
      </Tooltip>
      <Popover
        // className="saved-area-popover"

        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        sx={{
          marginLeft: '-0.75rem !important',
          '& .MuiPaper-root': {
            maxWidth: '271px !important',
            maxHeight: '260px !important',
            backgroundColor: 'var(--secondary-color) !important',
            // marginLeft: '-0.75rem !important',
            // padding: '0px !important',
          },
        }}
      >
        <Box>
          <Box sx={{ textAlign: 'center', marginTop: '1rem' }} className="">
            <Typography variant="h6">{'Layers'}</Typography>
            {/* <IconButton
                            onClick={() => {
                                // MixpanelTracking.getInstance().track(
                                //     MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_S_X
                                // );
                                handleClose();
                            }}
                        >
                            <ClearOutlinedIcon />
                        </IconButton> */}
          </Box>
          <Box className="layers-button-popover-content">
            <Scrollbar className="scroll-thumb-color">
              <List>
                <ListItem disablePadding>
                  <CoverageAccordion
                    checked={checked}
                    setChecked={setChecked}
                    groupLayer={groupLayer}
                    expanded={expanded}
                    handleChange={handleChange}
                  />
                </ListItem>
                {/* <ListItem disablePadding>
                                    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}

                                        >
                                            <Typography variant="subtitle2">
                                                Users
                                            </Typography>

                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus,
                                                varius pulvinar diam eros in elit. Pellentesque convallis laoreet
                                                laoreet.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </ListItem>
                                <ListItem disablePadding>
                                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}

                                        >
                                            <Typography variant="subtitle2">
                                                Advanced settings
                                            </Typography>

                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </ListItem>
                                <ListItem disablePadding>
                                    <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}

                                        >
                                            <Typography variant="subtitle2">
                                                EagleView
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </ListItem> */}
              </List>
            </Scrollbar>
          </Box>
          {/* {getPopOverContent(user)} */}
        </Box>
      </Popover>
    </>
  );
}
